//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    todo: {
      type: Object,
      required: true
    },
    allowEditTask: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    openEntriesDialog: function openEntriesDialog() {
      this.openDialog('EntriesDialog', {
        filters: {
          todo_ids: [this.todo.todo_id]
        }
      });
    },
    openLogDialog: function openLogDialog() {
      this.openDialog('EstimateLogDialog', {
        todoId: this.todo.todo_id,
        allowEditTask: this.allowEditTask
      });
    }
  }
};